import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import {Link} from "gatsby";

function WhiteBoxes(props) {
	const renderTitle = () => {
		if (props.content.body) {
			return (
				<>
					<div className='col-lg-6'>
						<h2>{props.content.title}</h2>
					</div>
					<div className='col-lg-5 offset-lg-1 d-flex align-items-center'>{renderRichText(props.content.body)}</div>
				</>
			);
		}

		return (
			<div className='col-12 pb-5'>
				<h2>{props.content.title}</h2>
			</div>
		);
	};

	const renderCta = (element) => {
		if (element.isExternal) {
			return (
				<a href={element.ctaUrl} target={'_blank'} rel={'noreferrer'} className={'more mt-4 text-decoration-none'}>
					<i className='fas fa-arrow-right' />
					{element.ctaText}
				</a>
			)
		}

		return (
			<Link to={element.ctaUrl} className={'more mt-4 text-decoration-none'}>
				<i className='fas fa-arrow-right' />
				{element.ctaText}
			</Link>
		)
	}

	const withoutCta = props.withoutCta !== undefined && props.withoutCta

	return (
		<section key={props.key} className='white-boxes-section'>
			<div class='decorate-container-white'>
				<div class='decorate'>
					<span class='decorate__item'></span>
					<span class='decorate__item'></span>
				</div>
			</div>
			<div className='container'>
				<div className='row project--header section--header'>{renderTitle()}</div>
				<div className='row start--container fix'>
					{props.content.elements.map((element, index) => {
						return (
							<div key={index} className='box-wrapper col-12 col-md-6 pb-5 pb-md-0'>
								<div className='box h-100'>
									<div className='decorate-container'>
										<div className='decorate'>
											<span className='decorate__item' />
											<span className='decorate__item' />
										</div>
									</div>
									<div className="cardbox--img">
                                        <img src={element?.image?.url} alt={element?.image?.title} />
                                    </div>
									<h5 className='mt-3'>{element.title}</h5>
									<div className="body">
                                        {renderRichText(element.body)}
                                    </div>
									{!withoutCta && renderCta(element)}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}

export default WhiteBoxes;
